import styled from "styled-components";

export const Container = styled.div``;

export const ContainerAddress = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
`;

export const ContainerProducts = styled.div`
  margin-top: 20px;
`;

export const ContainerFormOfPayment = styled.div`
  margin-top: 20px;
`;

export const Grid = styled.div`
  display: flex;
  gap: 5px;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardProducts = styled.div`
  background: #fafafa;
  margin-top: 4px;
`;

export const ContainerProductsTitle = styled.div<{ isColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: ${({ isColor }) => isColor ?? "initial"};
`;

export const Button = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;

export const ContainerDriverSelected = styled.div`
  display: flex;
  width: 160px;
  align-items: center;
  gap: 10px;
`;

export const ContainerDriver = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerSelected = styled.div`
  display: flex;
  width: 300px;
`;
